import { getHighestRole } from '../../../utils/RolesService';

export function setUser(profile) {
    if (window.clarity) {
        window.clarity('set', 'companyName', profile?.company?.name);
        window.clarity('set', 'companyType', profile?.company?.company_type);
        window.clarity('set', 'role', getHighestRole(profile?.roles || []));
    }
}